import { ExternalLink } from "./external-link";

const AI_TERMS_URL = "https://www.aptible.com/legal/ai-terms-of-service";

/** Link to Aptible's AI Terms of Service. */
export const AiTermsOfServiceLink = () => (
  <ExternalLink href={AI_TERMS_URL}>AI Terms of Service</ExternalLink>
);

/**
 * Consent line shown under an action that accepts the AI Terms of Service.
 * `action` completes the sentence "By {action}, I confirm ...".
 */
export const AiTermsConsent = ({ action }: { action: string }) => (
  <p className="text-gray-700 text-sm text-center">
    By {action}, I confirm that I have read and agree to Aptible's{" "}
    <AiTermsOfServiceLink />.
  </p>
);
